<script lang="ts" setup>
import {defineProps, ref, watch} from 'vue';
import {logEvent} from '/src/utils';

const props = defineProps<{
    activeTab: string;
    tabsOverride?: string[];
}>();
const emit = defineEmits(['setActiveTab']);

const tabs = ref(props.tabsOverride ?? ['code', 'images']);

watch(
    () => props.tabsOverride,
    (newValue) => {
        tabs.value = newValue ?? ['code', 'images'];
    }
);

function setActiveTab(tab) {
    emit('setActiveTab', tab);
    logEvent('button_select_tab', tab);
}
</script>
<template>
    <div class="fui-tabs">
        <div
            v-for="(tab, idx) in tabs"
            :key="idx"
            class="fui-tab font-bold"
            :class="{'fui-tab_active': activeTab === tab}"
            @click="setActiveTab(tab)"
        >
            {{ tab }}
        </div>
    </div>
</template>
<style lang="css">
.fui-tabs {
    display: flex;
}

.fui-tab {
    background: var(--secondary-color);
    border: 2px solid var(--border-dark-color);
    border-bottom: 0;
    border-radius: 6px 6px 0 0;
    color: var(--primary-color);
    height: 32px;
    vertical-align: middle;
    text-transform: uppercase;
    padding: 4px 12px 4px 12px;
    margin: 0 8px 0 0;
    cursor: pointer;
    line-height: 22px;
}

.fui-tab:hover,
.fui-tab_active {
    background-color: var(--primary-color);
    color: var(--secondary-color);
}
</style>
